exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".embeddedVideo{width:100%;height:100%}", "", {"version":3,"sources":["/build/src/code.justin.tv/web/wall/src/components/hls-player/style.css"],"names":[],"mappings":"AAAA,eACE,WAAY,AACZ,WAAa,CACd","file":"style.css","sourcesContent":[".embeddedVideo {\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./src/components/hls-player/style.css
// module id = 37
// module chunks = 0